import {
  Button,
  Checkbox,
  createTheme,
  FormControl,
  FormControlLabel,
  FormHelperText,
  FormLabel,
  Radio,
  RadioGroup,
  TextField,
  ThemeProvider,
} from "@mui/material";
import axios from "axios";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import login from "../../Assets/logo.jpg";
import logo from "../../Assets/logo1.png";
import { logInSchema } from "../../Schena/Login";
import { baseUrl } from "../../Config/baseUrl";
import { baseURL } from "../../Config/axios";
import OTPInput from "react-otp-input";

const SignIn = () => {
  const lightTheme = createTheme({
    palette: { mode: "light", primary: { main: "#1345B7" } },
  });

  const navigate = useNavigate();

  const [loginData, setLoginData] = useState({});
  const [goToOther, setGoToOther] = useState("");
  const [qrCode, setQrCode] = useState({});

  const [step, setStep] = useState(1);

  const [otp, setOtp] = useState("");
  const [toggleBtn, setToggleBtn] = useState(true);

  const initialValues = {
    email: "",
    password: "",
  };

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: logInSchema,
    onSubmit: (values) => {
      const reqBody = { email: values.email, password: values.password };

      axios
        .post(`${baseUrl}/blog/blog-store-login/`, {
          ...reqBody,
        })
        .then((res) => {
          if (res?.data?.response_code === 200) {
            setLoginData(res?.data);
            setToggleBtn(false);

            localStorage.setItem("token", res.data.token);
            localStorage.setItem("user_id", res.data.user_id);
            localStorage.setItem("store_id", res.data.store_id);
            localStorage.setItem("user_name", res.data.user_name);
            localStorage.setItem("email", res.data.email);
            localStorage.setItem("store_name", res.data.store_name);
            localStorage.setItem("role", res.data.role);
            localStorage.setItem("tab", JSON.stringify(res.data.tab));

            // window.location.reload();
            toast.success(res.data.message);
          } else {
            toast.error(res.data.message);
          }
        })

        .catch((error) => {
          toast.error(
            error.message === "Request failed with status code 400"
              ? "You have Entered Wrong Credential"
              : "",
          );
        });
    },
  });

  const sendOtpData = () => {
    console.log(otp, "otp");
    const reqBody = {
      // registration_id: registrationToken,
      // device_id: deviceIdData,
      type: "web",
      otp: otp,
    };

    axios
      .post(`${baseURL}/blog/verify-two-factor-authentication-api/`, reqBody, {
        headers: {
          Token: loginData?.token,
        },
      })
      .then((response) => {
        if (response?.data?.response_code === 200) {
          localStorage.setItem(
            "two_step_verification",
            response?.data?.two_step_verification,
          );
          if (loginData?.role === "SuperAdmin") {
            navigate("/storeHub");
          } else {
            navigate("/blog");
          }
          toast(response.data.message);
        } else {
          toast(response.data.message);
        }
      })
      .catch((error) => {
        console.log("", error);
      });
  };

  useEffect(() => {
    if (goToOther === "Yes") {
      axios
        .post(
          `${baseURL}/blog/generate-otp-qr-code-verification/`,
          {},
          {
            headers: {
              Token: loginData?.token,
            },
          },
        )
        .then((response) => {
          setQrCode(response?.data);
        })
        .catch((error) => {
          console.log("", error);
        });
    }
  }, [goToOther === "Yes"]);

  if (goToOther === "No") {
    localStorage.setItem(
      "two_step_verification",
      loginData.two_step_verification,
    );

    if (loginData?.role === "SuperAdmin") {
      navigate("/storeHub");
    } else {
      navigate("/blog");
    }

    toast(loginData.message);
  }

  console.log(loginData, "this is login data");

  return (
    <>
      <div className="flex">
        <img
          src={login}
          alt=""
          className="fixed object-cover w-screen h-screen"
        />
        <div className="flex flex-col h-screen items-center p-16 text-black md:w-[30%]  w-full border-r-2 border-opacity-10 bg-white bg-opacity-10 backdrop-blur-md">
          <img src={logo} alt="" className="mt-8 h-28" />
          {/* <p className="mt-10 text-2xl font-semibold text-red-500">Sign In</p>
          <p className="mt-4 text-xs">Sign in to stay connected.</p>
          <form
            onSubmit={formik.handleSubmit}
            className="flex flex-col w-full my-2"
          >
            <ThemeProvider theme={lightTheme}>
              <label className="py-1 mt-3">Email*</label>
              <TextField
                id="email"
                name="email"
                size="small"
                placeholder="Enter Email"
                onChange={formik.handleChange}
                onBlur={formik.onBlur}
                type="email"
                className="p-1 text-black bg-white border-2 rounded-md focus:outline-none bg-opacity-20 backdrop-blur-sm"
              />
              <FormHelperText className="!text-red-700 px-1">
                {formik.errors["email"]}
              </FormHelperText>
              <label className="py-1 mt-3">Password*</label>
              <TextField
                id="password"
                name="password"
                size="small"
                placeholder="Enter Password"
                value={formik.values["password"]}
                onChange={formik.handleChange}
                onBlur={formik.onBlur}
                type="password"
                className="rounded-md text-black p-1.5 focus:outline-none border-2 bg-white bg-opacity-20 backdrop-blur-sm"
              />
              <FormHelperText className="!text-red-700 px-1">
                {formik.errors["password"]}
              </FormHelperText>
              <div className="flex items-center justify-start w-full">
                <div className="flex items-center my-1">
                  <Checkbox className="!p-0 !pr-1" />
                  <p className="cursor-pointer">Remember Me</p>
                </div>
              </div>
              <div className="flex justify-center mt-5">
                <Button
                  variant="contained"
                  type={"submit"}
                  className="!px-10 !py-1.5 !capitalize !rounded-md"
                >
                  Sign In
                </Button>
              </div>
            </ThemeProvider>
          </form> */}

          {goToOther === "" && (
            <>
              {toggleBtn ? (
                <>
                  <p className="text-2xl font-semibold mt-3">Sign In</p>
                  <p className="mt-2 text-xs text-slate-600 font-serif">
                    Login into your account
                  </p>

                  <>
                    <form
                      onSubmit={formik.handleSubmit}
                      className="flex flex-col w-full my-2"
                    >
                      <ThemeProvider theme={lightTheme}>
                        <label className="py-1 mt-3">Email*</label>
                        <TextField
                          id="email"
                          name="email"
                          size="small"
                          placeholder="Enter Email"
                          onChange={formik.handleChange}
                          onBlur={formik.onBlur}
                          type="email"
                          className="p-1 text-black bg-white border-2 rounded-md focus:outline-none bg-opacity-20 backdrop-blur-sm"
                        />
                        <FormHelperText className="!text-red-700 px-1">
                          {formik.errors["email"]}
                        </FormHelperText>
                        <label className="py-1 mt-3">Password*</label>
                        <TextField
                          id="password"
                          name="password"
                          size="small"
                          placeholder="Enter Password"
                          value={formik.values["password"]}
                          onChange={formik.handleChange}
                          onBlur={formik.onBlur}
                          type="password"
                          className="rounded-md text-black p-1.5 focus:outline-none border-2 bg-white bg-opacity-20 backdrop-blur-sm"
                        />
                        <FormHelperText className="!text-red-700 px-1">
                          {formik.errors["password"]}
                        </FormHelperText>
                        <div className="flex items-center justify-start w-full">
                          <div className="flex items-center my-1">
                            <Checkbox className="!p-0 !pr-1" />
                            <p className="cursor-pointer">Remember Me</p>
                          </div>
                        </div>
                        <div className="flex justify-center mt-5">
                          <Button
                            variant="contained"
                            type={"submit"}
                            className="!px-10 !py-1.5 !capitalize !rounded-md"
                          >
                            Sign In
                          </Button>
                        </div>
                      </ThemeProvider>
                    </form>
                  </>
                </>
              ) : (
                <>
                  {
                    loginData?.two_step_verification === true ? (
                      <>
                        <div className="mt-16 rounded-xl p-5 bg-white">
                          <div className="text-center justify-center">
                            <img
                              src={
                                "https://www.freeiconspng.com/uploads/secure-icon-png-30.png"
                              }
                              className="h-12 mx-auto w-12"
                            />
                          </div>
                          <div className="text-center text-slate-800 font-bold text-lg py-3">
                            Enter OTP Code
                          </div>
                          <OTPInput
                            inputStyle="inputStyle"
                            value={otp}
                            onChange={setOtp}
                            numInputs={6}
                            // containerStyle={containerStyle}
                            renderSeparator={
                              <span className="!text-red-500"></span>
                            }
                            renderInput={(props) => <input {...props} />}
                            className="!p-2"
                            size="3"
                          />
                          <div className="py-2 mx-auto text-center">
                            <Button
                              size="small"
                              variant="contained"
                              onClick={sendOtpData}
                              className="!bg-blue-500"
                            >
                              Verify
                            </Button>
                          </div>
                        </div>
                      </>
                    ) : (
                      // <div className="mt-20 bg-white rounded-xl p-2">

                      <div className="mt-20">
                        <FormControl>
                          <FormLabel id="demo-radio-buttons-group-label">
                            <span className="!text-slate-800 text-sm">
                              Do You Want two step verification.
                            </span>
                          </FormLabel>
                          <RadioGroup
                            aria-labelledby="demo-radio-buttons-group-label"
                            defaultValue="female"
                            size="small"
                            name="radio-buttons-group"
                            onChange={(event) =>
                              setGoToOther(event.target.value)
                            }
                          >
                            <FormControlLabel
                              value="No"
                              control={<Radio />}
                              label="No"
                            />
                            <FormControlLabel
                              value="Yes"
                              control={<Radio />}
                              label="Yes"
                            />
                          </RadioGroup>
                        </FormControl>
                      </div>
                    )
                    // </div>
                  }
                </>
              )}
            </>
          )}

          {goToOther.length !== "" && (
            <>
              {goToOther === "Yes" && (
                <>
                  <div className="">
                    <div className="text-center text-slate-800 font-bold text-lg py-3">
                      OTP Verify
                    </div>
                    <img src={qrCode?.qcode} className="h-44 w-44" />
                  </div>
                  <>
                    <div className="mt-3">
                      <OTPInput
                        inputStyle="inputStyle"
                        value={otp}
                        onChange={setOtp}
                        numInputs={6}
                        // containerStyle={containerStyle}
                        renderSeparator={
                          <span className="!text-red-500"></span>
                        }
                        renderInput={(props) => <input {...props} />}
                      />
                      <div className="py-2 mx-auto text-center">
                        <Button
                          size="small"
                          variant="contained"
                          onClick={sendOtpData}
                          className="!bg-blue-500"
                        >
                          Verify
                        </Button>
                      </div>
                    </div>
                  </>
                </>
              )}
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default SignIn;
